import { scaleLinear } from 'd3-scale';

/** Data padding applied before building the y-scale — matches v1 `axis-utils`. */
export const Y_DATA_PADDING = 0.07;

/** Inset from the domain edges when picking visible ticks — matches v1 `getYAxisTicks`. */
export const Y_TICK_INSET = 0.05;

/** Fallback tick count when plot height is unavailable. */
export const TARGET_Y_TICKS = 6;

/** Mirrors turbo / v1: `Math.min(12, Math.ceil(height / 40))`. */
export const yAxisTickCount = (plotHeight: number): number =>
  Math.min(12, Math.max(1, Math.ceil(plotHeight / 40)));

/**
 * Pick y-axis ticks the same way the legacy turbo chart does: d3's nice
 * tick generator on the padded domain, then drop labels within 5% of the
 * top/bottom so they sit inset from the plot edges.
 */
export const getYAxisTicks = (
  domain: [number, number],
  ticksCount: number
): number[] => {
  const [d0, d1] = domain;

  if (d0 === d1 || !Number.isFinite(d0) || !Number.isFinite(d1)) {
    return [d0];
  }

  const span = Math.abs(d1 - d0);
  const offset = span * Y_TICK_INSET;

  return scaleLinear()
    .domain([d0, d1])
    .range([0, span])
    .ticks(ticksCount)
    .filter(t => t > d0 + offset && t < d1 - offset);
};
